import Base from "./Base";
import * as turf from '@turf/helpers'
import {TOOL_DRAW_POINT} from "./ToolType";

const POINT_LAYER_NAME = "DrawLineTool_POINT";


export default class DrawPointTool extends Base {
  /**
   *
   */
  constructor(options) {
    let params = {
      continueDraw: true,//是否连续绘制
      pointColor: "#00BFFF",//端点颜色
      pointSize: 5,//端点大小
      callBack: null,//绘制完成回调函数
      callBackName: null,//绘制完成回调地图事件名称
      errorCallBack: null,//错误回调函数
      moveCallBack: null,//绘制移动回调函数
      moveCallName: null,//绘制移动回调地图事件名称
      map: null,//地图实例
      showIcon: true,//是否展示图标
      iconCLassName: "iconfont-map map-icon-dian",//图标类名
      chineseName: "点",
      showPosition: false,
      innerUse: false,
    }
    Object.assign(params, options)

    super(params.map, TOOL_DRAW_POINT, params);
    this.params = params;

  }

  start() {
    super.start();
    //改变鼠标样式
    this._defaultCursor = this.map.getCanvas().style.cursor;
    this.map.getCanvas().style.cursor = "crosshair";
    this.coordinates = [];
    this.movePoint = null;

    this._addLayer();
    this._addEvent();

  }

  _addLayer() {
    let geoJson = turf.featureCollection([]);
    if (!this.map.getSource(POINT_LAYER_NAME)) {
      this.map.addSource(POINT_LAYER_NAME, {
        type: "geojson",
        data: geoJson,
      });
    }

    if (!this.map.getLayer(POINT_LAYER_NAME)) {
      this.map.addLayer({
        id: POINT_LAYER_NAME,
        type: "circle",
        source: POINT_LAYER_NAME,
        layout: {},
        paint: {
          'circle-color': this.params.pointColor,
          'circle-radius': this.params.pointSize,
        },
      });
    }
  }

  //更新线绘制
  _update() {
    let drawPoints = [].concat(this.coordinates);
    if (this.movePoint) {
      drawPoints.push(this.movePoint)
    }

    let points = [];
    for (let i = 0; i < drawPoints.length; i++) {
      points.push(turf.point(drawPoints[i]))
    }

    //绘制点
    this.map.getSource(POINT_LAYER_NAME).setData(turf.featureCollection(points));
  }


  close(notClearMap = false) {
    this.clear(notClearMap);
    this.clearEvent();
  }

  clear(notClearMap = false) {
    this.clearMap(notClearMap);
    this.enableViewMap();
  }

  clearMap(notClearMap = false) {
    this.map.getCanvas().style.cursor = this._defaultCursor;


    //不清除地图选择绘制图层
    if (!notClearMap) {
      super.clearMap();
    }
    this.removeDrawLayer();
    this.clearPopup();
  }

  //移除绘制图层
  removeDrawLayer() {
    if (this.map.getLayer(POINT_LAYER_NAME)) {
      this.map.removeLayer(POINT_LAYER_NAME);
    }
    if (this.map.getSource(POINT_LAYER_NAME)) {
      this.map.removeSource(POINT_LAYER_NAME);
    }
  }

  clearEvent() {
    super.clearEvent();
    this.map.off("click", this._clickEvent);
    this.map.off("mousemove", this._moveEvent);
    this.map.off("contextmenu", this._drawEndEvent);
    this.map.off("dblclick", this._drawEndEvent);
  }

  _addEvent() {
    this._clickEvent = (e) => {
      if(e._defaultPrevented){
        return;
      }
      this._preventDefault(e);
      console.log(this.clickBufferTime)
      if(this.clickBufferTime){
        this.clickBufferTime=false
        // this._dbClickEvent({type:"dblclick"})
        this.coordinates=this.coordinates
        this._drawEndEvent(e)
      }else  {
        this.coordinates.push([e.lngLat.lng, e.lngLat.lat]);

        if (this.params.showPosition) {
          this.addPopup(e.lngLat.lng.toFixed(3) + "，" + e.lngLat.lat.toFixed(3), turf.point([e.lngLat.lng, e.lngLat.lat]))
        }
        this._update()
        this.finish(this._getFeature());
        if (!this.params.continueDraw) {
          this.inActiveIcon();
        }


        this.clickBufferTime=true;
        setTimeout(()=>{
          this.clickBufferTime=false;
        },300)
      }


    }
    this.map.on('click', this._clickEvent)
    this._moveEvent = (e) => {
      this.movePoint = [e.lngLat.lng, e.lngLat.lat];
      this._update();

      if (this.params.moveCallBack) {
        this.params.moveCallBack([e.lngLat.lng, e.lngLat.lat]);
      }
      if (this.params.moveCallName) {
        this.map.fire(this.params.moveCallName, [e.lngLat.lng, e.lngLat.lat])
      }

    }
    this.map.on("mousemove", this._moveEvent);
    //双击或右键结束
    this._drawEndEvent = (e) => {
      this._preventDefault(e);
      this.finish(this._getFeature());
      this.inActiveIcon();
    }
    this.map.on("contextmenu", this._drawEndEvent);
    // this.map.on("dblclick", this._drawEndEvent);
  }


  _getFeature() {
    let points = [];
    for (let i = 0; i < this.coordinates.length; i++) {
      points.push(turf.point(this.coordinates[i]))
    }

    //绘制点
    return turf.featureCollection(points)

  }
}



// WEBPACK FOOTER //
// ./src/tool/edit/DrawPointTool.js